export default __webpack_public_path__ + "static/media/icon-table-visualizar.2aa56b3a.svg";